import { useMutation, useQueryClient } from "@tanstack/vue-query";
import OrganizationSetting from "@/services/organization/organization-setting";
import { UpdateAutoBucketSettings } from "@/dtos/OrganizationSetting.dto";

export function useUpdateAutoBucketSettings() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (settings: UpdateAutoBucketSettings) => {
      const result = await OrganizationSetting.updateAutoBucketSettings(settings);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to update auto bucket settings");
      }
      return result.data.data;
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["autoBucketSettings"] });
    },
  });
}
